module.exports = __webpack_public_path__ + "static/Auto-Share-2-e1407758998599-a3d45b1a725399248767dff166cdd5cd.jpg";